<div class="relative w-full h-full text-center" #backgroundContainer>
  @if (htmlBackgroundService.isEditingLabels()) {
    <div class="label-edit-banner absolute w-full p-4 bg-black/50 text-white/70" @fadeInOutAnimation>
      {{ 'COMPONENTS.AREAS.AREA_BACKGROUND.AREA_BACKGROUND_2D.HTML.LABEL_EDIT_BANNER' | translate }}
    </div>
  }
</div>

<ng-template #placeholderTemplate>
  <!-- Use inline styles as this component will be injected into HTML Content -->
  <div class="html-content-placeholder">
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 4.785 19.928" fill="#FFFFFF">
      <path id="information" d="M20.819,28.39H17.034V17.034h3.785Zm0-15.141H17.034V9.463h3.785Z" transform="translate(-16.534 -8.963)" stroke="rgba(0,0,0,0)" stroke-width="1"/>
    </svg>
    This is where your content will be displayed.
  </div>
</ng-template>
